import React, { useEffect, Fragment, useState } from "react";
import Breadcrumb from "../../common/breadcrumb";
import EventCharts from "./eventCharts";
import setHeader from "../../Functions/setHeader";
import axiosIntance from "../../../services/axiosConfig";
import LoadingComponent from "../../common/LoadingComponent";
import { SITE_URL } from "../../../services/Const";


const Default = () => {
  const [users, setUsers] = useState([]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    AllUsers();
    getData();
  }, []);

  const getData = () => {
    setLoading(true);
    setData([]); // Reset data before fetching new data

    axiosIntance.get("get-dashboard-data", setHeader())
      .then((res) => {
        setData(res.data.data);
        console.log(res.data.data);


      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // Function to fetch all users
  const AllUsers = async () => {
    try {
      const res = await axiosIntance.get("users-list", setHeader());
      const firstFive = res.data.data.slice(0, 5); // get first 5
      setUsers(firstFive);
    } catch (error) {
      console.log("Error fetching users:", error);
    }
  };

  if (loading) {
    return <div><LoadingComponent /></div>; // Show loading state
  }

  return (
    <Fragment>
      {/* <Breadcrumb parent="" title="Dashboard" /> */}
      <div className="container-fluid" style={{ paddingTop: "20px" }}>
        <div className="row">
          <div className="col-xl-8 xl-100">
            <div className="row">
              <EventCharts data={data} />
            </div>
          </div>
          {/* User List */}
          {users.length > 0 && (
            <div className="col-xl-4 xl-100 col-md-12">
              <div className="card height-equal" style={{ minHeight: "507px" }}>
                <div className="card-header card-header-border">
                  <div className="row">
                    <div className="col-sm-6">
                      <h5>New User</h5>
                    </div>

                  </div>
                </div>
                <div className="card-body">
                  <div className="new-users">
                    {users.map((user, index) => (
                      <div className="d-flex align-items-start mb-3" key={index}>
                        <img
                          className="rounded-circle image-radius m-r-15"
                          src={user.profileUrl || '/assets/images/download (6).png'} // fallback image
                          alt={user.name || 'Unknown'}
                        />
                        <div className="flex-grow-1">
                          <h6 className="mb-0 f-w-700">{user.name || user.username || user.email || 'Unknown'}</h6>
                          <p>{user.role || "No role specified"}</p>
                        </div>
                      </div>
                    ))}
                  </div>

                </div>
              </div>
            </div>
          )}
          <div className="row">
            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
              {/* Top Sellings List */}
              {data?.TopSellingProducts?.length > 0 && (
                // <div className="col-xl-12 xl-100 col-md-12">
                <div className="card height-equal">
                  <div className="card-header card-header-border">
                    <div className="row">
                      <div className="col-sm-6">
                        <h5>Top Selling Products</h5>
                      </div>

                    </div>
                  </div>
                  <div className="card-body">
                    <div className="new-users">
                      {data?.TopSellingProducts?.map((data, index) => (
                        <div className="d-flex align-items-start mb-3" key={index}>
                          <img
                            className="image-radius m-r-15"
                            src={`${SITE_URL}/images/product/${JSON.parse(data.images || '[]')[0] || ''}`}
                            alt={data.productName || 'Unknown'}
                          />
                          <div className="flex-grow-1">
                            <h6 className="mb-0 f-w-700">{data.productName || 'Unknown'}</h6>
                            <p>{data.productCode || "N/A"}</p>
                          </div>
                        </div>
                      ))}
                    </div>

                  </div>
                </div>
                // </div>
              )}
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
              {/* Top Low Stock List */}
              {data?.LowStockProducts?.length > 0 && (
                // <div className="col-xl-12 xl-100 col-md-12">
                <div className="card height-equal">
                  <div className="card-header card-header-border">
                    <div className="row">
                      <div className="col-sm-6">
                        <h5>Low Stock Products</h5>
                      </div>

                    </div>
                  </div>
                  <div className="card-body">
                    <div className="new-users">
                      {data?.LowStockProducts?.map((data, index) => (
                        <div className="d-flex align-items-start mb-3" key={index}>
                          <div style={{ width: '100px', height: '100px', overflow: 'hidden',display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <img
                              className=""
                              style={{width:'100%'}}
                              src={`${SITE_URL}/images/product/${JSON.parse(data.images || '[]')[0] || ''}`}
                              alt={data.productName || 'Unknown'}
                            />
                          </div>
                          <div className="flex-grow-1 pl-5" style={{paddingLeft:'1rem'}}>
                            <h6 className="mb-0 f-w-700">{data.productName || 'Unknown'}</h6>
                            <p>Available Stock : {data.stock_count || "0"}</p>
                          </div>
                        </div>
                      ))}
                    </div>

                  </div>
                </div>
                // </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Default;
